/* 🤖 this file was generated by svg-to-ts */
export const matIconArrowOutward: {
  name: 'arrow-outward';
  data: string;
} = {
  name: 'arrow-outward',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M6 6v2h8.59L5 17.59 6.41 19 16 9.41V18h2V6z"/></svg>`
};
